var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top"},[_c('span',{staticClass:"topChildren"},[_vm._v(_vm._s(_vm.headerNavName))]),_c('div',{staticClass:"like"})])
}
var staticRenderFns = []

export { render, staticRenderFns }